import {
  AbilityBuilder,
  AbilityClass,
  ConditionsMatcher,
  mongoQueryMatcher,
  PureAbility,
} from '@casl/ability';
import { type Ability, ActionEnum, Subjects } from 'abi-genome-common-types';

export type AbilityTuple = [`${ActionEnum}`, Subjects];

export type AppAbility = PureAbility<AbilityTuple>;

export function createUserAbility(
  _user?: unknown,
  rules?: AppAbility['_indexedRules'],
  abilities?: Ability[]
) {
  const { can, build, cannot } = new AbilityBuilder<AppAbility>(
    PureAbility as AbilityClass<AppAbility>
  );

  const userAbilities = abilities ?? [];

  userAbilities.forEach(({ action, subject, inverted }) => {
    if (inverted) {
      cannot(action, subject);
    } else {
      can(action, subject);
    }
  });

  const ability = build({
    conditionsMatcher: mongoQueryMatcher as ConditionsMatcher<unknown>,
  });

  if (rules) {
    ability.update(rules);
  }

  return ability;
}
